import { createRouter, createWebHistory } from "vue-router";
import AppRoot from "@app/app-root.vue";
import { webRoutes } from "./router/web-flow-routes/web-routes";
import { limitOrderRoutes } from "./router/limit-order/limit-order";
import { limitCreateRoutes, preapprovedLimitCreateRoutes } from "./router/limit/limit-routes";
import { contractCreateCustomerRoutes } from "./router/contract-create/contract-create-routes";
import { webOrderRoutes } from "./router/web-order/web-order";
import { posFinishOrderRoutes } from "./router/pos-finish-order/pos-finish-order";
import { informativeCalculationRoutes } from "./router/informative-calculation/informative-calculation-routes";
import { publicRoutes } from "./router/public/public-routes";
import { commClient } from "fw4-library";
import { usePublicStore } from "@app/store/app/public-store";

const ProcessEndScreenView = () => import("@views/public/process-end-screen-view.vue");
const TestPage = () => import("@views/public/web-test.vue");
const EmailVerificationNeeded = () => import("@views/app/landing-pages/email-verification-needed.vue");
const PrekinitevPostopka = () => import("@views/app/landing-pages/cancel-procedure.vue");
// const EmailVerification = () => import("@views/app/landing-pages/email-verification.vue");
const PetrolBarcode = () => import("@/app/views/public/petrol-barcode.vue");
const FinApiPage = () => import("@views/public/fin-api-page.vue");

const routes = [
    {
        component: AppRoot,
        path: "/",
        name: "home",
        children: [
            ...webRoutes,
            ...limitOrderRoutes,
            // ...limitRoutes,
            ...limitCreateRoutes,
            ...contractCreateCustomerRoutes,
            ...webOrderRoutes,
            ...posFinishOrderRoutes,
            ...publicRoutes,
            ...informativeCalculationRoutes,
            ...preapprovedLimitCreateRoutes,
            {
                component: PetrolBarcode,
                name: "PetrolBarcode",
                path: "/petrol-barcode/:id?",
                props: true
            },
        ],
    },
    {
        component: EmailVerificationNeeded,
        path: "/email-poslan/:type/:id?",
        name: "email_sent",
        props: true
    },
    // {
    //     component: EmailVerification,
    //     name: "email_verification",
    //     path: "/email-verifikacija/:type/:id",
    //     props: true
    // },
    // {
    //     component: TestPage,
    //     path: "/test",
    //     name: "test-page"
    // },
    {
        component: TestPage,
        path: "/test_1stavno_1411",
        name: "test-page"
    },
    {
        component: PrekinitevPostopka,
        name: "prekinitev_postopka",
        path: "/prekinitev-postopka/:id?",
        // path: "/prekinitev-postopka/:id",
        props: true
    },
    {
        component: ProcessEndScreenView,
        name: "ProcessEndScreen",
        path: "/process-end",
        props: true,
    },
    {
        component: FinApiPage,
        path: "/finapi_1211",
        name: "fin-api-page"
    },
];

const router = createRouter({
    history: createWebHistory(""),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    },
});

router.beforeEach(async (to) => {
    if (!to.meta.ipRestricted) return true;

        const Message: any = await commClient.executeMethodAsync("IsIPValid", {});

        if (Message) {
            if (Message.IsValid == false) {
                const publicStore = usePublicStore();
                return { name: 'PublicEndFail' };
            }
        }
    return true;
});

router.afterEach((to) => {
    if (typeof window === 'undefined') return

    const w = window as any

    w.teads_e = w.teads_e || []

    w.teads_e.push({
    conversionType: 'ViewContent',
    name: to.fullPath // better than pathname (includes query params)
    });

    // window.dataLayer.push({
    //     step_name: to.fullPath // better than pathname (includes query params)
    // });

//   if (to.name == 'limit_zacetek') {
//         injectGTM('GTM-KGZ468DH');
//     } 
//     else {
//         removeGTM();
//     }
});

export default router;
